import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Axios } from "../../../Api/axios";
import {
  ADMIN_ALL_INTENSIVE,
  ADMIN_DELETE_INTENSIVE,
  ADMIN_ALL_CLASSES,
  baseURL,
} from "../../../Api/Api";
import "../dash-cards.css";
import DashSelect from "../../../Components/Dashboard/DashSelect";

/* ─── Helpers ─── */
function parseSchedule(raw) {
  if (!raw) return [];
  try { const p = JSON.parse(raw); if (Array.isArray(p)) return p; } catch {}
  return [];
}

/* ─── Delete Confirm Modal ─── */
function DeleteModal({ course, onConfirm, onCancel, deleting }) {
  return (
    <div className="dc-overlay" onClick={!deleting ? onCancel : undefined}>
      <div className="dc-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dc-confirm-icon">
          <svg width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
        </div>
        <h3 className="dc-confirm-title">تأكيد الحذف</h3>
        <p className="dc-confirm-msg">
          هل تريد حذف الدورة{" "}
          <strong>"{course.name}"</strong>؟
          <br />
          <span className="dc-confirm-warn">لا يمكن التراجع عن هذا الإجراء</span>
        </p>
        <div className="dc-confirm-actions">
          <button className="dc-confirm-cancel" onClick={onCancel} disabled={deleting}>
            إلغاء
          </button>
          <button className="dc-confirm-delete" onClick={onConfirm} disabled={deleting}>
            {deleting ? "جاري الحذف..." : "حذف"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─── Card ─── */
function IntensiveCard({ course, onDeleteRequest }) {
  const photoUrl = course.photo
    ? `${baseURL}/uploads/intensive/${course.photo}`
    : null;

  return (
    <div className="dc-card">
      <div className="dc-card-cap" />

      <div className="dc-card-avatar">
        {photoUrl ? (
          <img src={photoUrl} alt={course.name} />
        ) : (
          <div className="dc-card-avatar-placeholder dc-avatar-dark">
            <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-7 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm6 13H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z" />
            </svg>
          </div>
        )}
      </div>

      <div className="dc-card-body">
        <h3 className="dc-card-name">{course.name || "—"}</h3>

        {course.subject_name && (
          <span className="dc-card-meta dc-meta-subject">
            <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zm0 12.45L4.21 11 12 6.55 19.79 11 12 15.45z" />
            </svg>
            {course.subject_name}
          </span>
        )}

        {course.class_name && (
          <span className="dc-card-meta dc-meta-class">
            <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
              <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
            {course.class_name}
          </span>
        )}

        {course.period && (
          <span className="dc-card-meta">
            <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm.5 5v6l4.3 2.5-.8 1.2L11 14V7h1.5z" />
            </svg>
            {course.period}
            {course.start_time ? ` · ${course.start_time}` : ""}
          </span>
        )}

        {parseSchedule(course.times).map((s, i) => (
          <span key={i} className="dc-card-meta dc-card-meta-green" style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
              <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" />
            </svg>
            <span style={{ fontWeight: 700 }}>{s.day}</span>
            {s.time && <span style={{ color: "#6b7280" }}>· {s.time}</span>}
            {s.hours && (
              <span style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, padding: "1px 6px", fontSize: "0.75rem", color: "#00a74f", fontWeight: 600 }}>
                {s.hours}س
              </span>
            )}
          </span>
        ))}
      </div>

      {/* Actions */}
      <div className="dc-card-actions">
        <Link to={`/dashboard/Intensive/${course.id}`} className="dc-action-btn dc-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
          </svg>
          تعديل
        </Link>
        <button
          className="dc-action-btn dc-delete-btn"
          onClick={() => onDeleteRequest(course)}
        >
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
          حذف
        </button>
      </div>
      <div className="dc-card-actions">
        <Link to={`/dashboard/Intensive/${course.id}/lectures`} className="dc-action-btn dc-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.89 2 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
          </svg>
          المحاضرات
        </Link>
        <Link to={`/dashboard/Intensive/${course.id}/enroll`} className="dc-action-btn dc-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
          </svg>
          تسجيل الطلاب
        </Link>
      </div>
    </div>
  );
}

/* ─── Skeleton ─── */
function SkeletonCard() {
  return (
    <div className="dc-card dc-skeleton">
      <div className="dc-card-cap" />
      <div className="dc-card-avatar" />
      <div className="dc-card-body" style={{ paddingBottom: 14 }}>
        <div className="dc-sk-line dc-sk-lg" />
        <div className="dc-sk-line dc-sk-sm" />
        <div className="dc-sk-line dc-sk-sm" />
      </div>
      <div className="dc-sk-actions">
        <div className="dc-sk-btn" style={{ borderBottomRightRadius: 18 }} />
        <div className="dc-sk-btn" style={{ borderBottomLeftRadius: 18 }} />
      </div>
    </div>
  );
}

/* ─── Main Page ─── */
export default function T_Intensive() {
  const [courses,       setCourses]      = useState([]);
  const [loading,       setLoading]      = useState(true);
  const [classes,       setClasses]      = useState([]);
  const [selectedClass, setSelected]     = useState("");
  const [pendingDelete, setPendingDelete] = useState(null); // course object
  const [deleting,      setDeleting]     = useState(false);

  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => setClasses(res.data.classes || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = selectedClass ? `&class_id=${selectedClass}&limit=100` : "&limit=100";
    Axios.get(ADMIN_ALL_INTENSIVE + params)
      .then((res) => setCourses(res.data.data || []))
      .catch(() => setCourses([]))
      .finally(() => setLoading(false));
  }, [selectedClass]);

  async function confirmDelete() {
    if (!pendingDelete) return;
    setDeleting(true);
    try {
      await Axios.delete(ADMIN_DELETE_INTENSIVE, { data: { intensive_id: pendingDelete.id } });
      setCourses((prev) => prev.filter((c) => c.id !== pendingDelete.id));
      setPendingDelete(null);
    } catch {
      /* keep modal open on error */
    } finally {
      setDeleting(false);
    }
  }

  return (
    <div className="dash-page">
      <div className="dash-page-header">
        <h1 className="dash-page-title">الدورات المكثفة</h1>
        <Link className="dash-add-btn" to="/dashboard/Intensive/add">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          إضافة دورة جديدة
        </Link>
      </div>

      {classes.length > 0 && (
        <div className="stu-filter-bar" style={{ marginBottom: 20 }}>
          <DashSelect
            value={selectedClass}
            onChange={setSelected}
            options={[
              { value: "", label: "كل الصفوف" },
              ...classes.map((c) => ({ value: c.id, label: c.name })),
            ]}
            icon={
              <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
                <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
              </svg>
            }
          />

          {selectedClass && (
            <button className="stu-filter-clear" onClick={() => setSelected("")}>
              <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
              إلغاء الفلتر
            </button>
          )}

          <span className="stu-filter-count">{courses.length} دورة</span>
        </div>
      )}

      <div className="card-grid">
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
        ) : courses.length === 0 ? (
          <div className="dc-empty">
            <svg width="56" height="56" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-7 14l-5-5 1.41-1.41L12 14.17l7.59-7.59L21 8l-9 9z" />
            </svg>
            <p>لا توجد دورات مكثفة بعد</p>
            <small>ابدأ بإضافة دورة جديدة</small>
          </div>
        ) : (
          courses.map((course) => (
            <IntensiveCard
              key={course.id}
              course={course}
              onDeleteRequest={setPendingDelete}
            />
          ))
        )}
      </div>

      {pendingDelete && (
        <DeleteModal
          course={pendingDelete}
          onConfirm={confirmDelete}
          onCancel={() => !deleting && setPendingDelete(null)}
          deleting={deleting}
        />
      )}
    </div>
  );
}
